/**
 * Format a price in öre (cents) as Swedish krona, e.g. 25900 → "259 kr".
 * All monetary values in the system are stored in öre.
 */
export function formatPrice(priceInOre: number): string {
  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: 'SEK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(priceInOre / 100);
}

/**
 * Format a price with 2 decimal places, e.g. 1466 → "14,66 kr".
 * Used for VAT amounts where precision matters.
 */
export function formatPriceWithDecimals(priceInOre: number): string {
  return new Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: 'SEK',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(priceInOre / 100);
}
